<template>
  <div class="links">
    <Links/>
  </div>
</template>

<script>
// @ is an alias to /src
import Links from '@/components/Links.vue'

export default {
  name: 'LinksPage',
  components: {
    Links
  }
}
</script>
